import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/LanguageSwitcher.css'; // Import the CSS file

const LanguageSwitcher = () => {
    const { i18n, t } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <div className='flex justify-center'>
            <button 
                className={`language-button polish-button ${i18n.language === 'pl' ? 'active' : ''}`}
                onClick={() => changeLanguage('pl')}
                title={t('switchToPolish')}
            >
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Flag_of_Poland.svg/640px-Flag_of_Poland.svg.png" alt="Poland Flag" className="w-4 h-4 mr-2" />
                {t('polish')}
            </button>
            <button 
                className={`language-button english-button ${i18n.language === 'en' ? 'active' : ''}`}
                onClick={() => changeLanguage('en')}
                title={t('switchToEnglish')}
            >
                <img src="https://upload.wikimedia.org/wikipedia/commons/0/05/Flag_of_the_U.S..svg" alt="USA Flag" className="w-4 h-4 mr-2" />
                {t('english')}
            </button>
            {/* Add more buttons for other languages */}
        </div>
    );
};

export default LanguageSwitcher; 